import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import "./App.css";

import { Spinner } from "reactstrap";

import ProgressSteps from "./components/UI/Progress/ProgressSteps";
import FormArea from "./components/FormArea";
import IntroArea from "./components/IntroArea";

import config from "./store/config";
import { fetchConfiguratorData } from "./store/configurator-actions";

let isInitial = true;
let defaultConfiguratorState = {
  skuId: 88,
  cartItemId: 0,
  apiEndpoint: 'http://localhost:25291/',
  productCollection: 3,
  csrfToken: ''
};

if (typeof window.SMA_DEFAULT_CONFIG !== "undefined") {
  config.settings = window.SMA_DEFAULT_CONFIG;
  defaultConfiguratorState = window.SMA_DEFAULT_CONFIG;
}

function App() {
  const dispatch = useDispatch();

  const currentRequestLoaded = useSelector(
    (state) => state.configurator.Loaded
  );
  const currentRequest = useSelector(
    (state) => state.configurator.ConfiguratorRequest
  );

  const [isDataLoaded, setIsDataLoaded] = useState(false);

  // load configurator state from api
  useEffect(() => {
    if (isInitial) {
      const fetchData = async () => {
        await dispatch(fetchConfiguratorData(defaultConfiguratorState));
        setIsDataLoaded(true);
      };

      fetchData();
      
      isInitial = false;
    }
  }, [dispatch, isDataLoaded]);

  if (isDataLoaded) {
    return (
      <div className="cfg">
        <ProgressSteps />
        <div className="row">
          <div className="col-sm-12 col-lg-4">
            <FormArea />
          </div>
          <div className="col-sm-12 col-lg-8">
            <IntroArea />
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="loading-spinner">
        <Spinner color="primary">Loading...</Spinner>
      </div>
    );
  }
}

export default App;
